import React, { Fragment, useRef } from 'react';
import MegaMenu from '../MegaMenu/MegaMenu';

const NavigationLink = ({
  link,
  isActive,
  onLinkHover,
  onMouseLeaveLink,
  blocks,
}) => (
  <li className="navbar__item">
    <a
      href={link.url || '#'}
      className={`navbar__link ${
        link.isSelected ? 'navbar__link--selected' : ''
      } ${isActive ? 'active' : ''} ${
        link.links?.length > 0 ? 'has-children' : ''
      }`}
      onTouchStart={onLinkHover}
      onMouseEnter={onLinkHover}
    >
      {link.name}
      {link.links?.length > 0 && <i className="navbar__megamenu-icon"></i>}
    </a>
    {link.links?.length > 0 && (
      <MegaMenu
        onMouseLeaveMegaMenu={onMouseLeaveLink}
        onMouseOverMegaMenu={() => onLinkHover(link)}
        link={link}
        open={isActive}
        blocks={blocks}
      />
    )}
  </li>
);

export default NavigationLink;
